
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/klassement",
      function () {
        return require("private-next-pages/klassement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/klassement"])
      });
    }
  